// src/gameLogics/pinisiKataData.js

/**
 * Basis data terpusat untuk permainan "Duel Pinisi Kata".
 * Berisi semua pertanyaan, pilihan jawaban, dan jawaban yang benar untuk setiap level.
 *
 * Struktur:
 * - level1, level2, level3: Kumpulan soal untuk setiap tingkat kesulitan.
 *   - question: Teks pertanyaan dengan placeholder `<blank>___</blank>`.
 *   - choices: Array berisi pilihan jawaban. Jawaban yang benar SELALU berada di indeks 0.
 *   - correct: Indeks jawaban yang benar (selalu 0 karena jawaban akan diacak saat ditampilkan).
 */

export const questionsDatabase = {
  level1: [
    {
      question: "Kapal Lancang Kuning berlayar di <blank>___</blank> yang tenang.",
      choices: ["laut", "darat", "udara", "gunung", "hutan"],
      correct: 0,
    },
    {
      question: "Anak-anak bermain di <blank>___</blank> sekolah.",
      choices: ["halaman", "atap", "basement", "langit", "sungai"],
      correct: 0,
    },
    {
      question: "Ibu memasak nasi di <blank>___</blank>.",
      choices: ["dapur", "kamar", "garasi", "taman", "kolam"],
      correct: 0,
    },
    {
      question: "Burung terbang di <blank>___</blank> yang biru.",
      choices: ["langit", "tanah", "air", "gua", "rumah"],
      correct: 0,
    },
    {
      question: "Ayah membaca <blank>___</blank> di pagi hari.",
      choices: ["koran", "sepatu", "piring", "bantal", "sapu"],
      correct: 0,
    },
    {
      question: "Petani menanam padi di <blank>___</blank>.",
      choices: ["sawah", "mall", "kantor", "sekolah", "hotel"],
      correct: 0,
    },
    {
      question: "Adik minum <blank>___</blank> setiap pagi.",
      choices: ["susu", "pasir", "batu", "kertas", "kayu"],
      correct: 0,
    },
    {
      question: "Kami belajar di <blank>___</blank> yang nyaman.",
      choices: ["kelas", "pasar", "stasiun", "bandara", "pelabuhan"],
      correct: 0,
    },
    {
      question: "Kakek duduk di <blank>___</blank> sambil membaca.",
      choices: ["kursi", "pohon", "mobil", "sepeda", "perahu"],
      correct: 0,
    },
    {
      question: "Kucing tidur di <blank>___</blank> yang empuk.",
      choices: ["kasur", "jalan", "atap", "pagar", "jembatan"],
      correct: 0,
    }
  ],
  level2: [
    {
      question: "Nelayan menangkap ikan dengan menggunakan <blank>___</blank>.",
      choices: ["jala", "pensil", "buku", "gunting", "penggaris"],
      correct: 0,
    },
    {
      question: "Dokter memeriksa pasien di <blank>___</blank>.",
      choices: ["rumah sakit", "toko buku", "restoran", "bioskop", "museum"],
      correct: 0,
    },
    {
      question: "Bunga mawar memiliki warna yang sangat <blank>___</blank>.",
      choices: ["indah", "pahit", "keras", "dingin", "berat"],
      correct: 0,
    },
    {
      question: "Pesawat terbang dengan <blank>___</blank> yang tinggi.",
      choices: ["kecepatan", "lambat", "diam", "jatuh", "tenggelam"],
      correct: 0,
    },
    {
      question: "Guru mengajar murid dengan penuh <blank>___</blank>.",
      choices: ["kesabaran", "kemarahan", "kebencian", "ketakutan", "kemalasan"],
      correct: 0,
    },
    {
      question: "Pohon kelapa tumbuh di daerah <blank>___</blank>.",
      choices: ["pantai", "kutub", "gurun", "gua", "danau"],
      correct: 0,
    },
    {
      question: "Atlet berlari dengan <blank>___</blank> untuk memenangkan lomba.",
      choices: ["cepat", "lambat", "malas", "tidur", "duduk"],
      correct: 0,
    },
    {
      question: "Perpustakaan adalah tempat untuk <blank>___</blank> buku.",
      choices: ["membaca", "memasak", "mencuci", "menyapu", "menjahit"],
      correct: 0,
    },
    {
      question: "Hujan turun dengan <blank>___</blank> di musim penghujan.",
      choices: ["deras", "panas", "kering", "beku", "hangat"],
      correct: 0,
    },
    {
      question: "Penjahit membuat baju dengan menggunakan <blank>___</blank>.",
      choices: ["benang", "air", "tanah", "api", "angin"],
      correct: 0,
    },
    {
      question: "Matahari terbit dari arah <blank>___</blank>.",
      choices: ["timur", "barat", "utara", "selatan", "tengah"],
      correct: 0,
    },
    {
      question: "Ikan hidup di dalam <blank>___</blank>.",
      choices: ["air", "udara", "tanah", "api", "es"],
      correct: 0,
    },
    {
      question: "Petani menggunakan <blank>___</blank> untuk membajak sawah.",
      choices: ["kerbau", "kucing", "burung", "ikan", "kelinci"],
      correct: 0,
    },
    {
      question: "Lampu memberikan <blank>___</blank> di malam hari.",
      choices: ["cahaya", "gelap", "dingin", "panas", "angin"],
      correct: 0,
    },
    {
      question: "Tukang kayu membuat meja dari <blank>___</blank>.",
      choices: ["kayu", "besi", "plastik", "kaca", "kertas"],
      correct: 0,
    }
  ],
  level3: [
    {
      question: "Kebudayaan Indonesia sangat <blank>___</blank> dan beragam.",
      choices: ["kaya", "miskin", "sederhana", "monoton", "seragam"],
      correct: 0,
    },
    {
      question: "Ilmuwan melakukan <blank>___</blank> untuk menemukan obat baru.",
      choices: ["penelitian", "permainan", "liburan", "tidur", "makan"],
      correct: 0,
    },
    {
      question: "Presiden memimpin negara dengan penuh <blank>___</blank>.",
      choices: ["tanggung jawab", "kemalasan", "ketidakpedulian", "kebencian", "kecerobohan"],
      correct: 0,
    },
    {
      question: "Teknologi berkembang dengan sangat <blank>___</blank> di era modern.",
      choices: ["pesat", "lambat", "stagnan", "mundur", "terhenti"],
      correct: 0,
    },
    {
      question: "Seniman menciptakan karya dengan penuh <blank>___</blank>.",
      choices: ["kreativitas", "kebosanan", "kemalasan", "keterpaksaan", "ketidakpedulian"],
      correct: 0,
    },
    {
      question: "Ekonomi negara mengalami <blank>___</blank> yang signifikan.",
      choices: ["pertumbuhan", "kemunduran", "kehancuran", "kebangkrutan", "keruntuhan"],
      correct: 0,
    },
    {
      question: "Diplomat bertugas menjaga <blank>___</blank> antar negara.",
      choices: ["hubungan", "permusuhan", "konflik", "peperangan", "perpecahan"],
      correct: 0,
    },
    {
      question: "Arsitek merancang bangunan dengan mempertimbangkan <blank>___</blank>.",
      choices: ["estetika", "keburukan", "kekacauan", "ketidakteraturan", "kerusakan"],
      correct: 0,
    },
    {
      question: "Jurnalis menulis berita dengan <blank>___</blank> yang tinggi.",
      choices: ["objektivitas", "keberpihakan", "kebohongan", "manipulasi", "distorsi"],
      correct: 0,
    },
    {
      question: "Ekosistem hutan memiliki <blank>___</blank> yang kompleks.",
      choices: ["keseimbangan", "kekacauan", "kehancuran", "kerusakan", "kepunahan"],
      correct: 0,
    },
    {
      question: "Filsuf memikirkan <blank>___</blank> kehidupan dengan mendalam.",
      choices: ["makna", "kebodohan", "kekosongan", "ketiadaan", "kehampaan"],
      correct: 0,
    },
    {
      question: "Astronot menjelajahi <blank>___</blank> dengan pesawat canggih.",
      choices: ["angkasa", "pasar", "sawah", "sungai", "jalan"],
      correct: 0,
    },
    {
      question: "Konstitusi mengatur <blank>___</blank> negara dan warga.",
      choices: ["hak", "kejahatan", "pelanggaran", "kesalahan", "keburukan"],
      correct: 0,
    },
    {
      question: "Komposer menciptakan musik dengan <blank>___</blank> yang indah.",
      choices: ["harmoni", "kekacauan", "kebisingan", "ketidakteraturan", "gangguan"],
      correct: 0,
    },
    {
      question: "Ahli biologi mempelajari <blank>___</blank> makhluk hidup.",
      choices: ["evolusi", "kepunahan", "kematian", "kehancuran", "kerusakan"],
      correct: 0,
    },
    {
      question: "Demokrasi memberikan <blank>___</blank> kepada rakyat.",
      choices: ["kebebasan", "penindasan", "perbudakan", "penjajahan", "pengekangan"],
      correct: 0,
    },
    {
      question: "Psikolog membantu pasien mengatasi <blank>___</blank> mental.",
      choices: ["gangguan", "kesehatan", "kebahagiaan", "ketenangan", "kedamaian"],
      correct: 0,
    },
    {
      question: "Globalisasi mempercepat <blank>___</blank> informasi.",
      choices: ["penyebaran", "penghambatan", "pembatasan", "penutupan", "penyembunyian"],
      correct: 0,
    },
    {
      question: "Entrepreneur membangun bisnis dengan <blank>___</blank> yang kuat.",
      choices: ["visi", "kebingungan", "keraguan", "ketidakpastian", "kegagalan"],
      correct: 0,
    },
    {
      question: "Konservasi bertujuan menjaga <blank>___</blank> alam.",
      choices: ["kelestarian", "kerusakan", "kehancuran", "kepunahan", "pengrusakan"],
      correct: 0,
    }
  ]
};